import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c342fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-icon" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "提交成功", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "请关注售后服务单状态，并保持电话畅通。", -1))
const _hoisted_5 = { class: "btn-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

import { useRoute, useRouter } from 'vue-router'
import AppHeader from '@/components/Header.vue'
import { Button } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-submit-success',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const guid = $route.query.guid as string

function toList() {
  $router.go(-1)
}

function continueConfirmHandler() {
  // 跳转到设备列表
  $router.replace({
    name: 'malfunction-repair-devices',
  })
}
function viewDetailHandler() {
  // 如果单个设备提单跳转到新创建服务单的详情页，如果多个设备提单则跳转到单据列表
  if (guid) {
    $router.replace({
      name: 'malfunction-repair-service-order-detail',
      query: {
        guid,
      },
    })
  } else {
    $router.replace({
      name: 'malfunction-repair-order-list',
      query: {
        guid,
      },
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      leftUseSlot: "",
      isReturnLeftEvent: "",
      onLeftClick: toList
    }, {
      left: _withCtx(() => [
        _createVNode(_component_van_icon, {
          class: "header",
          name: "cross"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Button), {
          color: "rgba(0, 195, 120, 1)",
          class: "continue-success-btn",
          onClick: viewDetailHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看单据")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          color: "rgba(0, 0, 0, 0.04)",
          style: _normalizeStyle({ color: 'rgba(0, 175, 108, 1) ' }),
          class: "view-btn",
          onClick: continueConfirmHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode("继续提单")
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ]),
    _hoisted_6
  ], 64))
}
}

})